import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@spartacus/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Udxb2bAttraction, Udxb2bAttractionAPICallData, Udxb2bExpressPassProduct } from '../../features/model';
import { UdxExpressPassAttractionsService } from '../../services/udx-express-pass-attractions.service';
import { AttractionCardComponent, SelectCardEventPayload } from './AttractionCardComponent/attraction-card.component';
// import { GrabVoucher } from '../../grab-redemption-service/grab-redemtion-service';

/* eslint-disable */
@Component({
    selector: 'cx-attraction-selection-dialog',
    templateUrl: './attraction-selection-dailog-component.html',
    styleUrls: ['./attraction-selection-dailog-component.scss'],
    imports: [
        I18nModule,
        MatDividerModule,
        MatDialogModule,
        MatIconModule,
        CommonModule,
        RouterModule,
        UrlModule,
        AttractionCardComponent,
    ]
})
export class AttractionSelectionDailogComponent implements OnInit {
  attractions$!: Observable<Udxb2bExpressPassProduct>;
  isAttractionSelected: boolean = false;
  selectedAttraction: Udxb2bAttraction = {
    selected: false,
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public dataObject: Udxb2bAttractionAPICallData,
    protected _attractionService: UdxExpressPassAttractionsService
  ) {}

  ngOnInit(): void {
    this.attractions$ = this._attractionService
      .getAttractions(this.dataObject.selectedDate!, Number(this.dataObject.quantity), this.dataObject.baseCode!)
      .pipe(
        tap((response) => {
          if (this.dataObject.variantSelectedCode) {
            response.products?.forEach((anAttraction) => {
              if (anAttraction.code === this.dataObject.variantSelectedCode) {
                anAttraction.selected = true;
              }
            });
          }
        })
      );
  }

  // selected = false;
  onSelectCard(data: Udxb2bAttraction[], product: Udxb2bAttraction) {
    this.isAttractionSelected = true;
    this.selectedAttraction = product;
    data.forEach((value) => {
      if (value.code == product.code) {
        product.selected = !product.selected;
      } else {
        value.selected = false;
      }
    });
  }

  onSelectCardEvent(eventPayload: SelectCardEventPayload) {
    this.onSelectCard(eventPayload.data, eventPayload.product);
  }

  getQueryParams() {
    return {
      selectedDate: this.dataObject.selectedDate,
      quantity: this.dataObject.quantity,
    };
  }
}
